import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];

      messages[locale] = locales(key);
    }
  });
  return messages;
}

const urlParams = new URLSearchParams(window.location.search);
const langQueryParam = urlParams.get("lang");
const savedLang = localStorage.getItem("lang");
const lang =
  langQueryParam ||
  savedLang ||
  (navigator.language || navigator.userLanguage).split("-")[0] ||
  "fr";
export default new VueI18n({
  locale: lang,
  fallbackLocale: lang,
  messages: loadLocaleMessages(),
});
